<template>

    <form ref="banco-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            
					<div class="form-group col-md-12">
                        <label for="nome">Nome</label>
                        <input type="text" class="form-control" name="nome" maxlength="80" placeholder="Nome" v-model="model.nome" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="numero">Número</label>
                        <input type="text" class="form-control" maxlength="3" name="numero" placeholder="Número" v-model="model.numero"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="digito">Dígito</label>
                        <input type="text" class="form-control" maxlength="2" name="digito" placeholder="Dígito" v-model="model.digito"  />
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="boletoSemRegistro" class="custom-control-input" v-model="model.boletoSemRegistro">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Gera Boleto Sem Registro?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="boletoComRegistro" class="custom-control-input" v-model="model.boletoComRegistro">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Gera Boleto Com Registro?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Ativo?</span>
                        </label>
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "banco-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "banco-form-create",
            
            resources: {
                create: 'banco',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

